import { UserAchievements } from "../routes/achievements/types";
import { useCurrentUser } from "@/libs/apis/onboarding/useUser";

export const useShowUserAchievements = (
  data: UserAchievements | undefined,
  swooshHandle: string,
) => {
  const userHasAchievements =
    data?.achievements && data.achievements.length > 0;
  const currentUserSwooshHandle = useCurrentUser().currentUser?.swooshHandle;
  const isCurrentUser = currentUserSwooshHandle === swooshHandle;
  const showPlaceholderAchievements = isCurrentUser && !userHasAchievements;

  return {
    showUserAchievements: userHasAchievements,
    showPlaceholderAchievements,
  };
};
